export default __webpack_public_path__ + "static/media/undraw_page_not_found_re_e9o6.4c33e24e.svg";